module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uz6q3Y/tc-custom/9781426819711.jpg?1718183148378",
      "alt": "This image is the cover for the book Double Jeopardy, The McClains"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Double Jeopardy, The McClains\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Witness to a brutal murder, Anne Jones bravely agrees to testify. She is given a new name, a new history and is advised not to get too close to anyone. But she doesand with good reason. Somehow, her identity has been compromised. Someone knows whoand whereshe is. Anne's handsome boss, Patrick McClain, is himself witness to the scare tactics being used against her and vows to keep her safe. Yet she will have to disappear all over again, lest she put both their lives in jeopardy."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Terri Reed\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award winning, multipublished author Terri Reed writes heart-warming romance and heart-pounding suspense. Her books have appeared on Publisher's Weekly top ten, Nielsen's Bookscan top fifty, Amazon Bestseller and featured in USA Today.  You can visit her online at www.terrireed.com or email her at terrireed@sterling.net ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0